import React from 'react';
import { motion } from 'framer-motion';

export const CommitChangeIcon: React.FC<{ isActive: boolean }> = ({
	isActive,
}) => {
	return (
		<motion.svg
			animate={isActive ? { scale: 1.2 } : null}
			width="100%"
			height="100%"
			viewBox="0 0 60 49"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M39.9383 31.2268L29.9727 21.2694L49.8792 11.3037L58.869 20.3018L39.9383 31.2268Z"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M20.0073 31.2269L10.0664 25.4956V37.8349L29.9481 47.8005L29.9729 21.2695L20.0073 31.2269Z"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M39.8875 31.2269L49.8284 25.4956V37.8349L29.9467 47.8005L29.9219 21.2695L39.8875 31.2269Z"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M20.0068 31.2268L29.9725 21.2694L10.066 11.3037L1.07617 20.3018L20.0068 31.2268Z"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M49.6647 11.0605L29.9134 1.18491L10.1621 11.0605"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M29.9141 1.5791V20.9353"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</motion.svg>
	);
};
